import { cn } from "@/lib/cn";

type Tone = "good" | "warn" | "bad" | "muted";

const TONE_STYLES: Record<Tone, string> = {
  good: "bg-green-50 text-green-700 border border-green-200",
  warn: "bg-amber-50 text-amber-700 border border-amber-200",
  bad: "bg-red-50 text-red-700 border border-red-200",
  muted: "bg-slate-50 text-slate-600 border border-slate-200",
};

const DOT: Record<Tone, string> = {
  good: "bg-green-500",
  warn: "bg-amber-500",
  bad: "bg-red-500",
  muted: "bg-slate-400",
};

interface StatusPillProps {
  label: string;
  tone?: Tone;
  className?: string;
  showDot?: boolean;
}

export function StatusPill({ label, tone = "muted", className, showDot = true }: StatusPillProps) {
  return (
    <span className={cn("pill", TONE_STYLES[tone], className)}>
      {showDot && <span className={cn("h-1.5 w-1.5 rounded-full", DOT[tone])} />}
      <span>{label}</span>
    </span>
  );
}
